<template>
  <Header
	  v-if="showLayout"
    :placeholder="placeholder"
    :mode="mode"
  />
	
	<div style="min-height: 800px;">
		<router-view></router-view>
	</div>
	
  <Footer
	  v-if="showLayout"
  />
	
	<SmartCustomerService />
</template>

<script>
import { onMounted, ref, reactive, computed, onBeforeUnmount, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import Header from './pages/Index/Header.vue';
import Footer from './components/Footer/Footer.vue'
import { useWindowResize } from "@/utils";
import { useRoute } from "vue-router";
import 'element-plus/theme-chalk/display.css'
import SmartCustomerService from "@/components/SmartCustomerService/SmartCustomerService.vue";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
export default {
  components:{
    Header,
    Footer,
	  SmartCustomerService
  },
  data() {
    return {
      showModal: false,
    };
  },
  setup() {
		const scrollPosition = ref(0)
	  const showLayout = ref(true)
	  
    const languageImg = reactive([
      {label: require('@/assets/images/index/中国.jpg'), value: 'zh-CN'},
      {label: require('@/assets/images/index/美国.jpg'), value: 'en-US'},
      {label: require('@/assets/images/index/德国.jpg'), value: 'de-DE'}
    ])

    const { locale } = useI18n();
    const store = useStore();
		const { windowSize, handleWindowResizeWithDebounce } = useWindowResize()
	  const route = useRoute()
		
		const mode = computed(() => scrollPosition.value > 50 ? 'dark' : 'light')
	  
	  const placeholder = computed(() => windowSize.value <= 1200)
	  
    const toggleLanguage = (item) => {
      locale.value = item.value;
      store.commit('setLanguage', locale)
    }
		
		const setClientId = async () => {
      if (!store.getters.clientId) {
	      const fp = await FingerprintJS.load();
	      const { visitorId } = await fp.get();
	      store.commit('setClientId', visitorId)
      }
    }
		
    onMounted(async () => {
	    await setClientId()
			store.dispatch('getCompanyInfo')
      store.dispatch("getLanguage");
			store.dispatch('getCozeAccessToken')
      locale.value = store.state.locale;
			window.addEventListener('scroll', updateScroll)
	    window.addEventListener('resize', handleWindowResizeWithDebounce)
    });
	  
	  onBeforeUnmount(() => {
			window.removeEventListener('scroll', updateScroll)
		  window.removeEventListener('resize', handleWindowResizeWithDebounce)
	  })

    const showModal = ref(false)

    const currentPath = ref(window.location.hash)

    window.addEventListener('hashchange', () => {
      currentPath.value = window.location.hash
    })

    const dropdown1 = ref()
    function showClick() {
      dropdown1.value.handleOpen()
    }
		
		const updateScroll = () => {
			scrollPosition.value = window.scrollY
		}
	  
	  watch(
		  () => route.meta,
		  (n, o) => {
				console.log('n --------->', n)
				if (n.hide) showLayout.value = false
			  else showLayout.value = true
		  }
	  )

    return {
			languageImg,
	    toggleLanguage,
	    showModal,
	    dropdown1,
	    showClick,
	    scrollPosition,
	    mode,
	    placeholder,
	    showLayout
		}
  },
};
</script>
<style scoped>
#Icon a {
  font-size: 70px;
  padding-top: 40px;
  display: none;
}
#nav {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #ffffff;
  z-index: 999;
}
.el-popper{
  top: 70px !important;
}
#app {
  /* background-color: red; */
  max-width: 1687px;
  padding: 0px auto;
  margin: 0px auto;
}
.nav-Icon img {
  width: 300px;
}
a:hover{
  color: red;
}
.Navigation {
  width: 60%;
}
.Navigation-ul {
  display: flex;
  list-style-type: none;
  justify-content: space-evenly;
}
.Navigation-li {
  padding-left: 25px;
  padding-top: 0px;
}
.Navigation-li a {
  text-decoration: none;
  color: black;
}
.nav-center {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.mask {
  background-color: #000;
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.pop {
  background-color: #fff;
  position: fixed;
   left: 35%; 
  z-index: 2;
}
.btn {
  float: left;
  border: none;
  background-color: #ffffff;
  position: relative;
  font-size: 18px;
}
.language {
  width: 13%;
  height: 79px;
}
.language img {
  margin: 16px 10px 6px 0px;
  width: 60px;
  height: 40px;
}

.el-dropdown {
  margin: 0 !important;
}
.example-showcase{
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}
.Navigation-li a{
  font-size: 20px;
}

@media screen and (min-width: 1683px) {
  .nav-center{
    max-width: 1726px;
  }
}
@media screen and (max-width: 1683px) and (min-width: 666px) {
  .Navigation-ul {
    display: none;
  }
  .language {
    min-width: 220px;
  }
  .btn {
    min-width: 70px;
  }
  #Icon a {
    display: inline;
  }
  .nav-center{
    min-width: 665px;
  }
  .btn img{
    width: 70%;
    height: 70%;
  }
}
@media screen and (max-width: 666px) {
  .Navigation-ul {
    display: none;
    width: 200px;
  }
  .Navigation-li a{
  font-size: 15px;
}
  .language {
    min-width: 130px;
  }
  .language img{
    padding-top: 10px;
    width: 25%;
    height: 33%;
  }
  .btn {
    min-width: 60px;
    font-size: 15px;
  }
  .iconfont{
    width: 300px;
  }
  #Icon a {
    display: inline;
    font-size: 50px;
  }
  .nav-Icon img{
    width: 120px;
  }
  .pop {
  background-color: #fff;
  position: fixed;
   left: 15%; 
  z-index: 2;
}
.btn img{
    width: 70%;
    height: 70%;
  }
}
</style>

